<template>
  <div class="contact__info">

    <a :href="`tel:${info.company.phone}`" class="info__item">
      <img src="@/assets/images/contacts/phone.svg" alt="">
      <p>{{ info.company.phoneForClient }}</p>
    </a>
    <a v-if="info.company.email" :href="`mailto:${info.company.email}`" class="info__item">
      <img src="@/assets/images/contacts/mail.svg" alt="">
      <p>{{ info.company.email }}</p>
    </a>
    <div class="info__item">
      <img src="@/assets/images/contacts/location.svg" alt="">
      <p>{{ info.company.address }}</p>
    </div>
    <div class="info__social">
      <a :href="link.href" class="social__item" v-for="link in info.links" :key="link.id">
        <img :src="require(`@/assets/images/contacts/${link.text.toLowerCase()}.svg`)" alt="">
      </a>
    </div>
  </div>
</template>


<script>

export default {
  name: 'Info',
  props: ['info'],
  data() {
    return {
      desktop: null
    }
  },
  methods: {
    checkWidth() {
      window.innerWidth <= 1200 ? this.desktop = false : this.desktop = true
    }
  },
  mounted() {
    this.checkWidth()
    window.addEventListener('resize', this.checkWidth)
  },
  unmounted() {
    window.removeEventListener('resize', this.checkWidth)
  }
}
</script>

<style scoped lang="scss">
.contact__info {
  margin: 0 0 0 46px;
  @media (max-width: 1200px) {
    margin: 0;
  }

  .read__all {
    @include disflex(flex, stretch, center);
    margin: 0 0 24px 44px;

    p {
      margin: 0 16px 0 0;
      color: #88BA4A;
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
    }

  }

  .info__item {
    @include disflex(flex, stretch, center);
    margin: 0 0 24px;
    color: #0E0252;

    &:nth-child(3) {
      margin: 0 0 32px;
      @media (max-width: 1200px) {
        margin: 0 0 8px;
      }
    }

    img {
      margin: 0 16px 0 0;
    }

    p {
      font-weight: 600;
      font-size: 31px;
      line-height: 40px;
      @media (max-width: 1920px) {
        @include adaptiv-fontAll(31, 20);
        @include adaptive-elem(line-height, 40, 26);
      }
    }
  }

  .info__social {
    @include disflex(flex, stretch, center);

    .social__item {
      @include disflex(flex, stretch, center);
      height: 42px;
      width: 42px;
      border-radius: 50%;
      background: #88BA4A;
      justify-content: center;
      margin: 0 32px 0 0;

      @media (max-width: 1920px) {
        @include adaptive-value("margin", 0, 32 24, 0, 0);
        @include adaptive-elem(width, 42, 40);
        @include adaptive-elem(height, 42, 40);
      }

      &:last-of-type {
        margin: 0;
      }
    }
  }

}
</style>